export abstract class TrackingBase {
    id: number;
	name: string;
    isActive: boolean;
	createdDate: string;
	modifiedDate: string;
	modifiedByUserId: number;
}
